var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8335 8.49992H6.50016V5.83325C6.50016 4.91658 6.8335 3.99992 7.50016 3.33325C8.16683 2.66659 9.0835 2.33325 10.0002 2.33325C11.6668 2.33325 13.1668 3.49992 13.5002 5.16658C13.5835 5.49992 13.9168 5.74992 14.2502 5.66658C14.5835 5.58325 14.8335 5.24992 14.7502 4.91659C14.3335 2.66659 12.3335 1.08325 10.0835 1.08325C8.8335 1.08325 7.5835 1.58325 6.66683 2.49992C5.66683 3.33325 5.16683 4.58325 5.16683 5.83325V8.49992H4.16683C2.91683 8.49992 1.8335 9.49992 1.8335 10.8333V16.6666C1.8335 17.9166 2.8335 18.9999 4.16683 18.9999H15.8335C17.0835 18.9999 18.1668 17.9999 18.1668 16.6666V10.8333C18.1668 9.58325 17.0835 8.49992 15.8335 8.49992ZM16.8335 16.6666C16.8335 17.2499 16.3335 17.6666 15.8335 17.6666H4.16683C3.5835 17.6666 3.16683 17.1666 3.16683 16.6666V10.8333C3.16683 10.2499 3.66683 9.83325 4.16683 9.83325H15.8335C16.4168 9.83325 16.8335 10.3333 16.8335 10.8333V16.6666Z",
    fill: "#003056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.2c3d974610dc7a042464e80fc96351e4.svg";
export { ForwardRef as ReactComponent };